// src/app/core/store/product/product.reducer.ts
import { createReducer, on } from '@ngrx/store';
import { ProductApiModel } from '@/core/models/api/concreto-product-api-model.model';
import * as ProductActions from './product.actions';

export interface ProductState {
  products: ProductApiModel[];
  pagination: {
    total: number;
    page_count: number;
    current_page: number;
    page_size: number;
    has_next: boolean;
    has_previous: boolean;
  };
  loading: boolean;
  error: any;
}

export const initialState: ProductState = {
  products: [],
  pagination: {
    total: 0,
    page_count: 0,
    current_page: 1,
    page_size: 50,
    has_next: false,
    has_previous: false
  },
  loading: false,
  error: null
};

export const productReducer = createReducer(
  initialState,
  on(ProductActions.loadProducts, (state) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(ProductActions.loadProductsSuccess, (state, { products, pagination }) => ({
    ...state,
    products,
    pagination,
    loading: false
  })),
  on(ProductActions.loadProductsFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false
  }))
);